import React from 'react'
import classNames from 'classnames/bind'
import { Head, Link } from '@inertiajs/react'
import { router } from '@inertiajs/react'
import AdminLayout from '@/admin/shell/layouts/AdminLayout'
import DataTable from '@/admin/shared/components/DataTable/DataTable'
import { TableSearch } from '@/admin/shared/components/DataTable/Toolbar'
import tableStyles from '@/admin/shared/components/DataTable/DataTable.module.scss'
import { COLUMNS } from '../components/UsersTable'
import type { UsersPageProps, User } from '../types'
import styles from '../Users.module.scss'

const cx = classNames.bind(styles)
const cxTable = classNames.bind(tableStyles)

function renderActions(user: User) {
  return (
    <Link href={`/admin/users/${user.id}`} className={cxTable('actionBtn')}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
      View
    </Link>
  )
}

function UsersPage({ users, search, status }: UsersPageProps) {
  const navigate = (params: Record<string, string | number | undefined>) =>
    router.get('/admin/users', params as Record<string, string>, { preserveState: true, replace: true })

  return (
    <>
      <Head title="Admin — Users" />
      <DataTable
        columns={COLUMNS}
        rows={users.data}
        total={users.total}
        page={users.current_page}
        perPage={users.per_page}
        lastPage={users.last_page}
        toolbarLeft={
          <>
            <TableSearch
              value={search}
              placeholder="Search by name or email…"
              onChange={q => navigate({ search: q || undefined, page: 1, status })}
            />
            <select
              className={cx('filterSelect')}
              value={status ?? ''}
              onChange={e => navigate({ status: e.target.value || undefined, page: 1, search })}
            >
              <option value="">All status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </>
        }
        onPageChange={p => navigate({ search, page: p, status })}
        onPerPageChange={n => navigate({ search, per_page: n, page: 1, status })}
        emptyMessage="No users found."
        selectable={false}
        actions={renderActions}
      />
    </>
  )
}

UsersPage.layout = (page: React.ReactNode) => (
  <AdminLayout title="Users">{page}</AdminLayout>
)

export default UsersPage
